import React from "react";

const Links = () => {
  return (
    <div className="container">
      <div className="page">
        <div className="main-error-wrapper  page page-h ">
          <img src="/img/back/19.png" alt="" />
          <h6>
            Digital EMC гар утасны программыг дараах холбоосууд дээр дарж татаж
            авах боломжтой.
          </h6>
          <div className="row">
            {" "}
            <a
              className="btn"
              href="https://apps.apple.com/us/app/digital-emc/id1600601152"
            >
              App Store
              <img
                className="m-2"
                src="/img/back/app-store.png"
                style={{ width: "25px" }}
                alt=""
              />
            </a>
            <a
              className="btn "
              href="https://play.google.com/store/apps/details?id=mn.erdenetmc.mbh.office"
            >
              Google Play
              <img
                className="m-2"
                src="/img/back/google-play.png"
                style={{ width: "25px" }}
                alt=""
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Links;
